import { IApplicationConfig, IAuthConfig } from "./application-config";

export interface CoreKitConfig {
  isProduction: boolean;
  apiUrl: string;
  selfServicePortalUrl?: string;
  authConfig?: IAuthConfig;
  redirectUrlKey?: keyof IApplicationConfig;
}
